export default __webpack_public_path__ + "static/media/img-intro-overview-ko.f645c63f.png";